/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { EsitiOperazioneDTO } from '../model/models';
import { ExceptionResponseDTO } from '../model/models';
import { GenericResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { ReportGenerazioneDovutiDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface CheckServizioMensaStatoDovutiRequestParams {
    gestioneMenseServizioId: string;
}

export interface GeneraServizioMensaConguaglioRequestParams {
    modalita: 'FINO_A_OGGI' | 'FINO_A_MESE_PRECEDENTE';
    gestioneMenseServizioId: string;
}

export interface RicalcolaServizioMensaRendicontazioniMeseRequestParams {
    mese: number;
    gestioneMenseServizioId: string;
    dataFinale?: string;
}

export interface RigeneraServizioMensaDovutiMeseRequestParams {
    mese: number;
    gestioneMenseServizioId: string;
}


export interface ServizioMensaPagamentiServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Verifica lo stato dei dovuti PagoPA del servizio mensa.
     * Interroga PagoPA per aggiornare lo stato delle ricariche in attesa del servizio (servizio risolto dall\&#39;header Gestione-Mense-Servizio-Id).
     * @endpoint put /api/v1/servizi/mensa/pagamenti/stato-dovuti
* @param requestParameters
     */
    checkServizioMensaStatoDovuti(requestParameters: CheckServizioMensaStatoDovutiRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Genera il conguaglio del servizio mensa.
     * Emette un avviso PagoPA per ogni studente in debito, pari al debito della modalita\&#39; scelta meno i conguagli gia\&#39; emessi e non pagati (rilanciabile senza doppi addebiti). FINO_A_OGGI &#x3D; saldo del borsellino a oggi; FINO_A_MESE_PRECEDENTE &#x3D; pasti fino a fine mese precedente meno i pagamenti fatti. Invia il report sul webhook e l\&#39;avviso ai genitori.
     * @endpoint put /api/v1/servizi/mensa/pagamenti/conguaglio
* @param requestParameters
     */
    generaServizioMensaConguaglio(requestParameters: GeneraServizioMensaConguaglioRequestParams, extraHttpRequestParams?: any): Observable<ReportGenerazioneDovutiDTO>;

    /**
     * Ricalcola le rendicontazioni del mese per il servizio mensa.
     * Ricalcola le rendicontazioni mensili del mese indicato per il servizio risolto dall\&#39;header. dataFinale opzionale filtra le ricariche considerate. Restituisce la lista di esiti.
     * @endpoint put /api/v1/servizi/mensa/pagamenti/ricalcola-rendicontazioni
* @param requestParameters
     */
    ricalcolaServizioMensaRendicontazioniMese(requestParameters: RicalcolaServizioMensaRendicontazioniMeseRequestParams, extraHttpRequestParams?: any): Observable<EsitiOperazioneDTO>;

    /**
     * Rigenera i dovuti PagoPA del mese per il servizio mensa.
     * Rigenera le posizioni debitorie del mese indicato per il servizio risolto dall\&#39;header. Invia il report sul webhook di segnalazione del servizio e le email di avviso-pagamento ai genitori interessati, poi restituisce il report (errori + email avvisate).
     * @endpoint put /api/v1/servizi/mensa/pagamenti/rigenera-dovuti
* @param requestParameters
     */
    rigeneraServizioMensaDovutiMese(requestParameters: RigeneraServizioMensaDovutiMeseRequestParams, extraHttpRequestParams?: any): Observable<ReportGenerazioneDovutiDTO>;

}
